<template>
    <v-card
        v-if="!!stats.length"
        :class="`mb-3 stat-list stat-list--${color} pa-1`"
        flat>
        <div
            :class="`ma-1 stat-list__chip stat-list-chip--${color} white--text`"
            :key="i"
            v-for="(stat, i) in stats">
            <span
                class="stat-list__stat">
                <span class="font-weight-bold">{{ formatBigNumber(stat.count, stat.isPercent) }}</span> <span> {{ stat.name }}</span>
            </span>
        </div>
    </v-card>
</template>

<script>
import NumberUtilities from "../../utilities/NumberUtilities";

export default {
    name: "stat-list",
    props: {
        color: String,
        stats: Array
    },
    mixins: [
        NumberUtilities
    ],
}
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";
    @import "../../styles/_mixins.scss";

    .stat-list {
        &--primary {
            @include statList($primary, $primaryLighten2)
        }

        &--gotv {
            @include statList($gotv, $gotvLighten2)
        }

        &--lgbtq {
            @include statList($lgbtq, $lgbtqLighten2)
        }

        &--latino {
            @include statList($latino, $latinoLighten2)
        }

        &--aapi {
            @include statList($aapi, $aapiLighten2)
        }

        &--all {
            @include statList($all, $allLighten2)
        }

        &--black {
            @include statList($black, $blackLighten2)
        }

        &--flipped {
            @include statList($flipped, $flippedLighten2)
        }

        &--new {
            @include statList($new, $newLighten2)
        }

        &--poc {
            @include statList($poc, $pocLighten2)
        }

        &--technology {
            @include statList($technology, $technologyLighten2)
        }

        &--women {
            @include statList($women, $womenLighten2)
        }

        &--native_american {
            @include statList($nativeAmerican, $nativeAmericanLighten2)
        }
    }

    .stat-list-chip {
        &--primary {
            @include statListChip($primary)
        }

        &--gotv {
            @include statListChip($gotv)
        }

        &--lgbtq {
            @include statListChip($lgbtq)
        }

        &--latino {
            @include statListChip($latino)
        }

        &--aapi {
            @include statListChip($aapi)
        }

        &--all {
            @include statListChip($all)
        }

        &--black {
            @include statListChip($black)
        }

        &--flipped {
            @include statListChip($flipped)
        }

        &--new {
            @include statListChip($new)
        }

        &--poc {
            @include statListChip($poc)
        }

        &--technology {
            @include statListChip($technology)
        }

        &--women {
            @include statListChip($women)
        }

        &--native_american {
            @include statListChip($nativeAmerican)
        }
    }
</style>